window.$ = window.jQuery = require('jquery')
window.underscore = window._ = require("underscore")
window.Backbone = require("backbone");
window.wNumb = require("wNumb")
window.moment = require('moment')
require('moment/locale/ru')
require('clndr')
window.store = require("store/dist/store.everything");
require("bootstrap")
require("magnific-popup")
require("waypoints/lib/jquery.waypoints")
require("jquery-lazyload/jquery.lazyload")
require("jquery-lazyload/jquery.scrollstop")
require("./other_vendors/jquery.clickable.min")
require("./other_vendors/get-documents")
require("./other_vendors/dropzone.min")
require("./other_vendors/device.min")
require("jscrollpane/script/jquery.mousewheel")
require("jscrollpane/script/mwheelIntent")
require("jscrollpane/script/jquery.jscrollpane")
require("chosen-js")
window.autosize = require("autosize")
require("./other_vendors/jquery.slowscroll.min")
require("jquery.cookie/jquery.cookie")
require("jquery-countdown/dist/jquery.countdown")
window.anime = require("animejs")
window.Choices = require("choices.js")
require("waypoints/lib/shortcuts/sticky")
require("waypoints/lib/shortcuts/inview")
require("./affix")
require("jquery.maskedinput/src/jquery.maskedinput")
require("@popperjs/core")
require("slick-carousel")
